import { FrontendFileReader } from './file-readers/frontend-file-reader';
export { FrontendFileReader } from './file-readers/frontend-file-reader';
export { DdfCsvError } from './ddfcsv-error';
import { prepareDDFCsvReaderObject } from './ddfcsv-reader';
export const getDDFCsvReaderObject = prepareDDFCsvReaderObject(new FrontendFileReader());
const __VERSION = '4.5.6';
const __BUILD = '1771890078305';
const __PACKAGE_JSON_FIELDS = {"name":"@vizabi/reader-ddfcsv","description":"Vizabi DDFcsv reader"};
export const versionInfo = { version: __VERSION, build: __BUILD, package: __PACKAGE_JSON_FIELDS };
export const version = __VERSION;
//# sourceMappingURL=index-web.js.map